import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore,
} from "oidc-client-ts";
// @ts-ignore
import urlparse from "url-parse";

const envVariables = import.meta.env;
const SCOPES = envVariables.VITE_SCOPES as string;

export default class AuthenticationHelper {
  public static _userManager: UserManager;
  public constructor() {
    if (AuthenticationHelper._userManager) return;

    const settings: UserManagerSettings = {
      authority: envVariables.VITE_AUTHORITY,
      client_id: envVariables.VITE_CLIENT_ID,
      redirect_uri: window.location.origin + envVariables.VITE_REDIRECT_URI,
      post_logout_redirect_uri:
      window.location.origin + envVariables.VITE_POST_LOGOUT_REDIRECT_URI,
      silent_redirect_uri: window.location.origin + envVariables.VITE_SILENT_REDIRECT_URI,
      response_type: envVariables.VITE_RESPONSE_TYPE,
      scope: envVariables.VITE_SCOPES,
      
      loadUserInfo: envVariables.VITE_LOADUSERINFO,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      stateStore: new WebStorageStateStore({ store: window.localStorage }),
    };
    AuthenticationHelper._userManager = new UserManager(settings);
    // on peut soit activer le silent renew en tâche de fond
    // on peut l'arrêter en appelant la méthode stopSilentRenew()
    AuthenticationHelper._userManager.startSilentRenew();

    // ou bien on peut utiliser les events pour
    // faire un signinSilent quand l'event d'expiration est déclenché
    AuthenticationHelper._userManager.events.addAccessTokenExpiring(() => {
      console.log("Token expiring - tentative de silent refresh...");
      AuthenticationHelper._userManager
        .signinSilent()
        .then(() => {
          console.log("Silent refresh réussi");
        })
        .catch((error) => {
          console.error("Silent refresh échoué:", error);
          // Fallback: redirection vers la page de connexion
          AuthenticationHelper._userManager.signinRedirect();
        });
    });
  }
  public login() {
    AuthenticationHelper._userManager.signinRedirect();
  }
  public api() {
    AuthenticationHelper._userManager.getUser().then((user: any) => {
      return user;
    });
  }

  public logout() {
    AuthenticationHelper._userManager.signoutRedirect();
  }

  public async getUserInfo() {
    const user = await AuthenticationHelper._userManager.getUser();
    return user;
  }
  public getAccessToken(): Promise<string> {
    return AuthenticationHelper._userManager.getUser().then((data: any) => {
      return data?.access_token;
    });
  }
  public getClaim(claimName: string): Promise<string> {
    return AuthenticationHelper._userManager
      .getUser()
      .then((data: any) => {
        return data.profile[claimName];
      })
      .catch((e: any) => {
        return "";
      });
  }

  public async handleLoginResponse(): Promise<void> {
    history.pushState({}, "Signin", window.location.href.replace("/#", "")); //Permet d'enlever le "/#" dans l'url (sans recharger la page) qui empêche la lecture du paramètre de redirection

    const urlData: any = urlparse(window.location.href, true);

    if (urlData?.query.state) {
      const storedState =
        await AuthenticationHelper._userManager.settings.stateStore?.get(
          urlData.query.state,
        );
      if (storedState) {
        const redirectLocation = "/";
        try {
          const user =
            await AuthenticationHelper._userManager.signinRedirectCallback();
        } catch (e: any) {
          console.log("erreur : " + e);
        } finally {
          // on retire syneliaconnect de l'historique de navigation
          // pour que l'utilisateur n'y revienne pas en cliquant
          // sur la navigation arrière
          history.replaceState({}, document.title, redirectLocation);
        }
      }
    }
  }
  public async silentRenew(): Promise<void> {
    console.log("Silent renew");
    await AuthenticationHelper._userManager.signinSilent();
    console.log("Silent renew terminé");
  }
  public async silentRenewStart() {
    console.log("Start Silent renew");
    AuthenticationHelper._userManager.startSilentRenew();
  }
  public async stopSilentRenew() {
    console.log("Stop Silent renew");

    AuthenticationHelper._userManager.stopSilentRenew();
  }
  public async MakeHeader() {
    console.log("Make Header");
  }
}
